import { Logger } from '@epihub/core/src/logger';
import { packageConst } from './package';

export const log = new Logger({
  packageConst,
});
